// extracted by mini-css-extract-plugin
export default {"download-link":"LogoAndIcon_download-link__XWL2N","logo-image":"LogoAndIcon_logo-image__F3Lf1"};